import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { Helmet } from "react-helmet-async";
import MembershipMoto from "../../../components/MembershipMoto";
import MemberSearch from "../../../components/MemberSearch";
import "./AboutUs.css";

const AboutUs = () => {
  return (
    <>
      <Helmet>
        <title>About Us | Manav Adhikar Forum</title>
        <meta
          name="description"
          content="Learn about Manav Adhikar Forum, an initiative dedicated to protecting and promoting human rights in India and across the globe."
        />
        <meta
          name="keywords"
          content="Manav Adhikar Forum, human rights, equality, justice, India, MAF, awareness, campaigns"
        />
        <link rel="canonical" href="https://manavadhikarforum.in/About-Us" />
      </Helmet>

      <Container className="py-5" style={{ padding: "0 12px" }}>
        <Row>
          {/* Left Section (40%) */}
          <Col md={5} className="d-flex flex-column ">
            <div className="mb-3">
              <MemberSearch />
            </div>

            <div className="flex-grow-1 d-flex">
              <MembershipMoto className="w-100 h-100" />
            </div>
          </Col>

          {/* Right Section (60%) */}
          <Col md={7}>
            <Card className="shadow-lg border-0">
              <Card.Body className="watermark">
                <div className="d-flex flex-column mb-4 text-center align-items-center">
                  <h2 className="fw-bold " style={{ color: "#1a5276" }}>
                    Manav Adhikar Forum
                    <div
                      className="rounded-pill mt-2 bg-warning"
                      style={{
                        height: "5px",
                        width: "18%",
                        // backgroundColor: "#EC1F24",
                      }}
                    ></div>
                  </h2>
                </div>

                <p
                  className="  text-secondary para"
                  style={{ fontSize: "1.15rem", textAlign: "justify" }}
                >
                  The modern concept of <strong>human rights</strong> gained
                  significant prominence after World War II, particularly in
                  response to the atrocities of the Holocaust, leading to the
                  adoption of the{" "}
                  <strong>Universal Declaration of Human Rights (UDHR)</strong>{" "}
                  by the United Nations General Assembly in 1948. This landmark
                  document outlined a framework of rights that countries are
                  encouraged to protect, setting a global standard for{" "}
                  <em>dignity, freedom, and justice</em>.
                </p>
                {/* <p className="  text-secondary"  style={{ fontSize: "1.15rem", textAlign: "justify" }}>
                  Over time, the UDHR has inspired international treaties and
                  national laws designed to safeguard these rights globally.
                  While the principle of universal rights is widely accepted,
                  debates still persist about their cultural interpretations,
                  enforcement, and priority. Some critics argue from the lens of{" "}
                  <strong>cultural relativism</strong>, claiming that universal
                  rights may conflict with local traditions and collective
                  identities.
                </p> */}
                <p
                  className="  text-secondary para"
                  style={{ fontSize: "1.15rem", textAlign: "justify" }}
                >
                  In <strong>India</strong>, the struggle for human rights has
                  deep roots in the freedom movement and the values enshrined in
                  the <strong>Constitution of India</strong>. Fundamental Rights
                  guarantee equality, freedom of speech, protection against
                  discrimination, and the right to life with dignity.
                  Institutions such as the{" "}
                  <strong>National Human Rights Commission (NHRC)</strong> and
                  various state bodies actively monitor violations, while civil
                  society organizations, activists, and the judiciary play
                  crucial roles in defending citizens’ rights.
                </p>
                <p
                  className="  text-secondary para"
                  style={{ fontSize: "1.15rem", textAlign: "justify" }}
                >
                  The <strong>Manav Adhikar Forum</strong> was founded with the
                  mission of raising awareness, promoting education, and
                  advocating for stronger human rights protections. We work
                  towards empowering vulnerable communities, amplifying voices
                  against injustice, and fostering a culture of{" "}
                  <strong>compassion, equality, and accountability</strong>.
                </p>
                <p
                  className="  text-secondary para"
                  style={{ fontSize: "1.15rem", textAlign: "justify" }}
                >
                  Today, human rights remain at the center of{" "}
                  <em>global governance and social progress</em>, and our forum
                  aspires to be a platform for dialogue, learning, and action.
                  Together, we strive for a future where{" "}
                  <strong>
                    justice and dignity are not privileges, but universal
                    guarantees
                  </strong>
                  .
                </p>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default AboutUs;
